import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrieveEducationalAdvisorBatches } from "./retrieve-educational-advisor-batches";
import type { BatchListItemVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

const initialState: RetrievalState<BatchListItemVM[]> = { data: [], fetching: "idle" };

export const retrieveEducationalAdvisorBatchesReducer = createReducer<RetrievalState<BatchListItemVM[]>>(initialState, builder => {
  builder.addCase(retrieveEducationalAdvisorBatches.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveEducationalAdvisorBatches.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveEducationalAdvisorBatches.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
